<template>
  <div class="date-container">
    <span>Your brand</span>
    <DashboardCalendarPicker
      id="benchmarks-header-calendar"
      class="category-calendar"
      :value="initialDateValue"
      :minDate="minDate"
      :maxDate="maxDate"
      :isMultipleOptionVariant="true"
      @applyContinueClick="handleApplyContinue"
      @click="handleApply"
    ></DashboardCalendarPicker>
    <span>compared to</span>
    <Select
      v-model="localComparisonQuarter"
      label="Benchmark Date Range"
      name="benchmarkPeriods"
      :options="benchmarksQuarters"
      :show="show"
      @input="handleDropdownSelection"
    ></Select>
  </div>
</template>

<script>
import { Select } from '@mikmak/components';
import DashboardCalendarPicker from '../../Common/DashboardCalendarPicker.vue';
import { getPredefinedQuarters } from '../../../../services/dashboard/dates/datesService';

export default {
  props: {
    initialDateValue: {
      type: Object,
    },
    comparisonQuarter: {
      type: Number,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
  },
  components: {
    DashboardCalendarPicker,
    Select,
  },
  data() {
    return {
      localComparisonQuarter: this.comparisonQuarter,
      predefinedQuarters: getPredefinedQuarters(),
      show: false,
    };
  },
  computed: {
    benchmarksQuarters() {
      return [...this.predefinedQuarters].sort((a, b) => {
        return a.range.start > b.range.start ? -1 : 1;
      });
    },
  },
  watch: {
    comparisonQuarter() {
      this.localComparisonQuarter = this.comparisonQuarter;
    },
  },
  methods: {
    /**
    * Since the Select component maintains its own local state for whether or not it is open,
    * we need to set it to false and then true to always trigger the local state of the component
    * to open
    */
    handleApplyContinue(val) {
      this.show = false;
      this.$nextTick(() => this.show = true);
      this.$emit('updateInitialDateRange', val);
    },
    handleApply(val) {
      this.$emit('applyInitialDateRange', val);
    },
    handleDropdownSelection(val) {
      this.$emit('applyComparisonQuarter', this.predefinedQuarters[val]);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-container {
  display: flex;
  align-items: center;
  padding-right: 24px;

  & ::v-deep ul.options {
    overflow-y: auto;
  }
}

.date-container > span {
  display: inline-block;
  white-space: nowrap;
  margin: 0px 16px;
  color: #778699;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
}

.date-container > .wrapper {
  max-width: 230px;
  margin-top: 2px;
}

#benchmarks-header-calendar {
  width: 335px;
  height: 0;
}
</style>

<style>
.benchmarks-header #benchmarks-header-calendar .picker-container.dropdown {
  right: 0;
  z-index: 2;
}

.benchmarks-header #benchmarks-header-calendar .date-range-control-wrapper {
  background: transparent;
  top: -21px;
}

.benchmarks-header #benchmarks-header-calendar .date-range-control {
  background: #FFFFFF;
  cursor: pointer;
}

.benchmarks-header #benchmarks-header-calendar span.date {
  display: inline-block;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 4px;
}

.benchmarks-header #benchmarks-header-calendar .help-text {
  background: transparent;
  padding: 0 12px;
  z-index: 2;
}
</style>
